export default {
  SERVICECENTERS_LIST: "Service centers list",
  ADD_SERVICECENTER: "Add service center",
  SERVICECENTER_ADDED: "Service center added",
  EDIT_SERVICECENTER: "Update service center",
  SERVICECENTER_UPDATED: "Service center updated",
  DELETE_THIS_SERVICECENTER: "Delete this service center ?",
  SERVICECENTER_DELETED: "Service center deleted",
};
